// Chakra imports
import { Box, SlideFade, Flex, Icon, Image, Text } from '@chakra-ui/react';
import { Dashboard } from 'api/types';
// Custom components
import Card from 'components/card/Card';

import { getIcon } from 'components/icons/Icons';

export default function DashboardElement(props: {
	clickAction?: (event: any) => void;
	dashboard: Dashboard
	index: number
}) {
	const { clickAction, dashboard, index } = props;
	const textColor = 'white';
	const iconDimentions = { base: '65px', '2xl': '75px' }

	return (
		<SlideFade in={true} offsetX={index % 2 === 0 ? '30px' : '-30px'} delay={index / 6}>
			<Card px='20px' py={{ base: '2vh' }} w='fit-content' h='fit-content' role='group' _hover={{ background: 'navy.700' }} onClick={clickAction}>
				<Flex direction={{ base: 'column' }} justify='center'>
					<Box mb={{ base: '20px', xl: '1.5vh' }} position='relative'>
						<Image
							src={process.env.REACT_APP_BASE_URL + dashboard.backgroundImage}
							w={{ base: '230px' }}
							h={{ base: '110px', lg: '14vh' }}
							borderRadius='20px'
						/>
						<Flex
							position='absolute'
							bg='transparent'
							top={{ base: '16%', '2xl': '21%' }}
							right='33%'
							w='80px'
							h='80px'
							justifyContent='center'

						>
							<Icon
								_groupHover={{ transform: 'scale(1.2)'  }}
								alignSelf='center'
								w={iconDimentions}
								h={iconDimentions}
								p='10px !important'
								transition='0.2s linear'
								as={getIcon(dashboard.icon)}
								color='white'
								filter='drop-shadow(5px 5px 5px rgb(0 0 0 / 0.2))'
							/>
						</Flex>

					</Box>
					<Flex flexDirection='column' justify='space-between' h='100%'>
						<Flex
							justify='space-between'
							direction={{
								base: 'row',
							}}
							mb='auto'>
							<Flex direction='column' w='100%'>
								<Text
									color={textColor}
									fontSize={{
										base: 'md',
										md: 'sm',
									}}
									mb='5px'
									fontWeight='bold'
									alignSelf='center'
									me='14px'>
									{dashboard.name}
								</Text>
								<Text
									color='secondaryGray.600'
									fontSize={{
										base: '12px'
									}}
									fontWeight='400'
									alignSelf='center'
									me='14px'>
									Creado el {dashboard.createdAt.toLocaleString()}
								</Text>
							</Flex>

						</Flex>
					</Flex>
				</Flex>
			</Card>
		</SlideFade>
	);
}
